import request from '@/utils/request'

// 查询商品列表
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新商品
export function updateProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.updateProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新商品上下架状态
export function updateProductState(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.updateProductState',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量更新商品上下架状态
export function batchUpdateProductState(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.batchUpdateProductState',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量开启同步自动上下架
export function batchEnableSyncAutoShelf(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.batchEnableSyncAutoShelf',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品分类
export function queryProductCategory(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.queryProductCategory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询仓库列表
export function queryShopHouse(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.queryShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询家政类型
export function queryHousekeepingType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.queryHousekeepingType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品H5菜单
export function queryProductH5Menu(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productH5Menu.listProductH5Menu',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存商品H5菜单
export function saveProductH5Menu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productH5Menu.saveProductH5Menu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除商品H5菜单
export function deleteProductH5Menu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productH5Menu.deleteProductH5Menu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除商品
export function deleteProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.deleteProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品规格
export function queryProductSpec(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/queryProductSpec',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存商品规格
export function saveProductSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSpec.saveProductSpec',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新商品规格
export function updateProductSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSpec.updateProductSpec',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除商品规格
export function deleteProductSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSpec.deleteProductSpec',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存商品标签
export function saveProductLabel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/saveProductLabel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询标签列表
export function queryLabel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/label/queryLabel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出数据
export function exportData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存商品
export function saveProduct(data) { 
  return new Promise((resolve, reject) => {
    request({
      url: '/product.saveProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询配送方式
export function queryDistributionMode(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode/queryDistributionMode',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存配送方式
export function saveDistributionMode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode/saveDistributionMode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新配送方式
export function updateDistributionMode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode/updateDistributionMode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除配送方式
export function deleteDistributionMode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/distributionMode/deleteDistributionMode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传文件
export function uploadFile(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/upload/uploadFile',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}